import { SCREEN } from "helper/roleChecker/Screens";
import { ActionLikeParams, GetNewsDetailParams } from "./paramsTypes";

export const getNewsTabsUrl = ({ screenCode }) =>
  `portal-news/news-category/${screenCode}`;

export const getNewsUrl = ({ screenCode }) => `portal-news/post/${screenCode}`;

export const getCommentsURL = ({
  screenCode,
  type,
  objectId,
}: {
  screenCode: SCREEN;
  type: string;
  objectId: number;
}) => `portal-interaction/comment/${screenCode}/${type}/${objectId}`;

export const postCommentURL = ({ screenCode }: { screenCode: SCREEN }) =>
  `portal-interaction/comment/${screenCode}`;

export const getNewsDetailURL = ({ screenCode, id }: GetNewsDetailParams) =>
  `portal-news/post/${screenCode}/${id}`;

export const likeNewsURL = ({ screenCode, id, type }: ActionLikeParams) =>
  `portal-interaction/like/${screenCode}/${type}/${id}`;
